import uniq from 'lodash/uniq';
import isInteger from 'lodash/isInteger';
import { requiredJobFields, optionalJobFields } from '../../constants';
import { url as urlRegex } from '../../../components/form';

const separateInvalid = bid => {
  if (parseFloat(bid)) {
    return parseFloat(bid) * 1000;
  } else if (bid === '0' || bid === 0) {
    return 0;
  }
  return null;
};

const bidIsMills = bid => {
  const isInt = isInteger(bid);
  if (isInt) {
    const toMills = isInt > 0 && isInt < 10 ? bid : bid * 1000;
    return toMills;
  } else if (!isInt) {
    const toMills = separateInvalid(bid);
    return toMills;
  }
};

const isUrl = value => {
  const response = urlRegex(value);

  return response === undefined ? true : false;
};

const isFormattedDate = value => {
  if (value === null) {
    return false;
  }
  if (new Date(value).toDateString() === 'Invalid Date') {
    return false;
  }
  if (value.split('/').length !== 3) {
    return false;
  }

  return true;
};

export const hasRequiredFields = json => {
  const missingF = [];
  const missing = [];
  const data = Array.isArray(json) ? json : [json];
  const newJobs = data.map((job, index) => {
    const sanitizedJob = { job_number: index + 1, ...job };

    if (sanitizedJob.bid) {
      sanitizedJob.bid = bidIsMills(job.bid);
    } else {
      delete sanitizedJob.bid;
    }

    if (!isFormattedDate(job.date)) {
      missing.push(sanitizedJob);
      sanitizedJob.date = 'Invalid Date';
    } else {
      sanitizedJob.date = new Date(job.date);
    }

    if (!isUrl(sanitizedJob.url)) {
      missing.push(sanitizedJob);
      sanitizedJob.url = 'Invalid URL';
    }

    requiredJobFields.forEach(field => {
      if (!sanitizedJob[field]) {
        if (missingF.length <= requiredJobFields.length * 2) {
          missingF.push(field);
        }
        missing.push(sanitizedJob);
      }

      // All fields (except those in the array) need to be sent as strings to the backend so convert if not in list and they exist
      if (!['bid', 'url', 'date'].includes(field) && sanitizedJob[field]) {
        sanitizedJob[field] = String(job[field]);
      }
    });

    optionalJobFields.forEach(field => {
      // Convert all optional fields to string if they exist and are not nil, if not, remove field from job
      if (sanitizedJob[field] && sanitizedJob[field] !== '') {
        sanitizedJob[field] = String(job[field]);
      } else {
        delete sanitizedJob[field];
      }
    });

    return sanitizedJob;
  });

  return missing.length || missingF.length ? { missing: uniq(missing), missingFields: uniq(missingF) } : { jobs: newJobs };
};
